module.exports = __webpack_public_path__ + "img/key.52de1835.svg";